import { authSelectors } from 'ducks/auth'
import { FujiTourType } from 'ducks/tour'
import { shouldSuppressE2eOverlays } from 'e2e/shouldSuppressE2eOverlays'
import { viewModeSelectors } from 'ducks/viewMode'
import { useMemo } from 'react'
import { useSelector } from 'react-redux'
import { RootState } from 'types/state'

const disabledWidths = ['sm', 'xs', 'xxs']

export const useShowTourBanner = (width: string, tourType: FujiTourType = 'main') => {
  const fujiTourEnabled = useSelector(viewModeSelectors.fujiTourEnabled)
  const isMobileDevice = useMemo(() => window.Utils?.isTouchDevice(), [])
  const shouldShowTour = useSelector((state: RootState) => authSelectors.getShowTourBanner(state, tourType))

  const tourConditionsPass =
    //mobile screen check
    !isMobileDevice &&
    !disabledWidths.includes(width) &&
    //is lite check
    fujiTourEnabled

  const showBanner =
    tourConditionsPass && !!(shouldShowTour?.shouldShow && !shouldShowTour?.userHidIt) && !shouldSuppressE2eOverlays()
  return {
    tourConditionsPass,
    showBanner,
  }
}
